import type { LexCounselMessage } from '../store/lexCounselStore';

export type CounselActiveSendRef = {
  current: { sendId: string; cancelInFlight?: () => void } | null;
};

export type CounselSendGuard = {
  sendId: string;
  isActive: () => boolean;
  onMessages: (
    updater: LexCounselMessage[] | ((prev: LexCounselMessage[]) => LexCounselMessage[]),
  ) => void;
  persist: (history: LexCounselMessage[]) => Promise<void>;
};

export function createCounselSendGuard(
  sendId: string,
  ac: AbortController,
  activeSendRef: CounselActiveSendRef,
  onMessages: CounselSendGuard['onMessages'],
  persist: (history: LexCounselMessage[]) => Promise<void>,
): CounselSendGuard {
  const isActive = () =>
    !ac.signal.aborted && activeSendRef.current?.sendId === sendId;

  return {
    sendId,
    isActive,
    onMessages: (updater) => {
      if (!isActive()) return;
      onMessages(updater);
    },
    persist: async (history) => {
      if (!isActive()) return;
      await persist(history);
    },
  };
}

export function registerCounselSendCancel(
  activeSendRef: CounselActiveSendRef,
  sendId: string,
  cancel: () => void,
): void {
  if (activeSendRef.current?.sendId === sendId) {
    activeSendRef.current.cancelInFlight = cancel;
  }
}
